<template>
	<div class="product">
		<div class="productInfo">
			<img :src="list.img" alt="">
			<div>
				<h2>{{list.common_name}}</h2>
				<p class="p_1" >暂无简介</p>
				<p class="p_2" ><span>{{list.specification}}</span></p>
				<p class="p_3" >药网价 <span>$ {{list.price}}</span></p>
				<div class="p_4">
					<img src="../assets/iphone.png" alt="">
					<p>手机扫码更方便,
						<span>立即扫码<img class="img" src="../assets/erweima.png" alt=""></span>
						>
					</p>
				</div>
			</div>
		</div>
		<div class="info_1">
			<p>商品详情</p>
			<div class="infos">
				<span>商品名称:{{list.common_name}}</span>
				<div>
					<span>商品品牌:暂无</span>
					<span>规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格:暂无规格</span>
				</div>
				<div>
					<span>重       量:{{list.specification}}</span>
					<span>生产厂商:{{list.manufacture}}</span>
				</div>
				<span>批准文号:{{list.license_no}}</span>
				<span>温馨提示:暂无提示</span>
			</div>
		</div>
		<div class="info_2">
			请仔细阅读药品说明书注意事项,禁忌等内容,按照说明书或者在药师指导下购买和使用,将药品置于儿童无法触及的位置.
		</div>
		<div class="info_3">
			<p>用法用量</p>
			<span>暂无数据</span>
		</div>
		<div class="info_4">
			<p>产品参数</p>
			<div>
				<span>通 用 名:暂无通用名</span>
				<span>适用人群:暂无数据</span>
				<span>禁   忌:暂无数据</span>
				<span>产品规格:暂无规格</span>
			</div>
		</div>
	</div>
</template>

<script>
	// 引入axios
	import axios from 'axios';
	// 引入端口配置文件
	import API_LIST from '@/list.config.js';
	import {
		ElMessageBox,
		ElMessage
	} from 'element-plus'
	import qs from 'qs'
	export default {
		
		name: "Search",
		data() {
			return {
				list:[]
			}
	
		},
		props: {
			
		},
		watch: {
	
		},
		created() {
			
			const that = this;
			this.id = this.$route.query.id;

			axios.post(API_LIST.info, {
					id: that.id
				}, {
					headers: {
						// 'Content-Type': 'application/x-www-form-urlencoded'
						'Content-Type': 'application/json'
					} //加上这个x
				})
				.then(_d => {
					console.log(_d.data)
					if (_d.data.status == 200) {
						// console.log(_d)
						that.list = _d.data.list;
						
					} else if (_d.data.status == 409) {
			
					}
			
			
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		mounted() {
			
		},
		methods: {
			detail(_id){
				this.$router.push({
					path:'/ProductDetail',
					query:{
						id:_id
					}
				})
			},
			// 上一页
			shang() {
				const that = this;
				if (this.page == 1) {
					ElMessage({
						message: '已经是第一页了',
						type: 'warning',
					})
				} else {
					this.ind--;
					this.page--;
					if (this.page < this.num[0]) {
						that.num = this.generateArray(this.num[0] - 5, this.num[0] - 1)
						this.ind = 4;
					}
					axios.post(API_LIST.drug_list, {
							page: this.page,
							gc_name2:this.name
						}, {
							headers: {
								// 'Content-Type': 'application/x-www-form-urlencoded'
								'Content-Type': 'application/json'
							} //加上这个x
						})
						.then(_d => {
							console.log(_d.data)
							if (_d.data.status == 200) {
								// console.log(_d)
								that.list = _d.data.list.list;
			
								that.counts = _d.data.list.page;
								if (_d.data.list.page == 0) {
									that.hidden = false;
									return false
								}
								if (that.num.length + 5 < that.counts) {
									that.num = this.generateArray(1, 5)
									that.show = true
								} else {
									that.num = that.counts
									that.show = false
								}
							} else if (_d.data.status == 409) {
			
							}
			
			
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			// 下一页
			xia() {
				const that = this;
				if (that.page == that.counts) {
					ElMessage({
						message: '已经是最后一页了',
						type: 'warning',
					})
				} else {
					this.ind++;
					this.page++;
					if (this.page > this.num[4]) {
						that.num = this.generateArray(this.num[4] + 1, this.num[4] + 5)
						this.ind = 0;
					}
					axios.post(API_LIST.drug_list, {
							page: this.page,
							gc_name2:this.name
						}, {
							headers: {
								// 'Content-Type': 'application/x-www-form-urlencoded'
								'Content-Type': 'application/json'
							} //加上这个x
						})
						.then(_d => {
							console.log(_d.data)
							if (_d.data.status == 200) {
								// console.log(_d)
								that.list = _d.data.list.list;
			
								that.counts = _d.data.list.page;
			
			
							} else if (_d.data.status == 409) {
			
							}
			
			
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			
			},
			// 点击选择
			click_id(item){
				const that = this;
				this.ind = item-1;
				this.page = item;
				
				axios.post(API_LIST.drug_list, {
						page: this.page,
						gc_name2:this.name
					}, {
						headers: {
							// 'Content-Type': 'application/x-www-form-urlencoded'
							'Content-Type': 'application/json'
						} //加上这个x
					})
					.then(_d => {
						console.log(_d.data)
						if (_d.data.status == 200) {
							// console.log(_d)
							that.list = _d.data.list.list;
							that.counts = _d.data.list.page;
							
						} else if (_d.data.status == 409) {
							
						}
							
							
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			generateArray(start, end) {
				return Array.from(new Array(end + 1).keys()).slice(start)
			}
			
		},
		
	};
</script>

<style scoped="scoped" lang="scss">
	.product{
		width: 850px;
		.productInfo{
			display: flex;
			flex-direction: row;
			img{
				width: 292px;
				height: 287px;
			}
			div{
				display: flex;
				flex-direction: column;
				margin: 0 0 0 10px;
				box-sizing: border-box;
				padding: 10px 0;
				h2{
					width: 476px;
					height: 21px;
					overflow: hidden;
				}
				.p_1{
					width: 476px;
					height: 32px;
					font-size: 12px;
					overflow: hidden;
					color: #FD3030;
				}
				.p_2{
					margin: 30px 0;
					span{
						color: #FD3030;
						border: 1px solid #fd3030;
						box-sizing: border-box;
						padding: 1px 2px;
						font-size: 14px;
					}
					// width: 50px;
				}
				.p_3{
					display: flex;
					flex-direction: row;
					span{
						color: #F83935;
						margin: 0 0 0 10px;
						font-weight: 800;
					}
				}
				.p_4{
					display: flex;
					flex-direction: row;
					align-items: center;
					margin: 40px 0 0 0;
					img{
						width: 15px;
						height: 20px;
						margin: 0 5px;
					}
					p{
						font-size: 16px;
						color: #7d7d7d;
						position: relative;
						span{
							color: #F83935;
							cursor: pointer;
						}
						
						img{
							position: absolute;
							width: 93px;
							height: 105px;
							top: -100px;
							right: 0;
							margin: 0 0px;
							// display: none;
							display: none;
						}
						span:hover .img{
							display: block;
						}
					}
				}
			}
		}
		.info_1{
			display: flex;
			flex-direction: column;
			margin: 20px 0 0 0;
			p{
				color: #39A49B;
				font-size: 16px;
			}
			.infos{
				display: flex;
				flex-direction: column;
				background-color: #fff;
				box-sizing: border-box;
				padding: 10px;
				span{
					display: inline-block;
					width: 300px;
					color: #717171;
					font-size: 16px;
					margin: 0 80px 10px 0;
					overflow: hidden;
					height: 21px;
				}
			}
		}
		.info_2{
			background-color: #fff;
			color: #7D7D7D;
			margin: 15px 0;
			box-sizing: border-box;
			padding: 5px 0;
		}
		.info_3{
			display: flex;
			flex-direction: column;
			p{
				color: #4AAEA5;
			}
			span{
				background-color: #fff;
				color: #7D7D7D;
				padding: 5px 0;
			}
			
		}
		.info_4{
			display: flex;
			flex-direction: column;
			margin: 15px 0;
			p{
				color: #4AAEA5;
			}
			div{
				display: flex;
				flex-direction: column;
				background-color: #fff;
				box-sizing: border-box;
				padding: 0 10px;
				span{
					margin: 10px 0;
				}
			}
		}
	}
</style>
